import React from 'react';
import './Header.css';
import logo from "../../../../../../../assets/logo.svg";
import logoText from "../../../../../../../assets/skali-logo-text.svg";
import { useStore } from '../../../../../../../Hooks/useStore';

const Header = () => {
    const { rootStore } = useStore();
    const handleLoginClick = ()=>{
        rootStore.userStore.setStep(1)
    }
    return (
        <header className="header-container">
            <div className="logo-container">
                <a href="/"> <img src={logo} /></a>
                <a href=""> <img className="logo-text" src={logoText} /></a>
            </div>

                <div className="nav-container">
                    <ul className='nav-links'>
                        <li>
                            <a href='https://www.skalillc.com/how-it-works' target='__blank'>How it works</a>
                        </li>
                        <li>
                            <a href='/'>Solutions</a>
                            <ul className='solution-dropdown'>
                                <li>
                                    <a href='https://www.skalillc.com/for-aviation/' target='_blank'>For Aviation</a>
                                </li>
                                <li>
                                    <a href='https://www.skalillc.com/for-maritime/' target='_blank'>For Maritime</a>
                                </li>
                                <li>
                                    <a href='https://www.skalillc.com/for-oil-gas/' target='_blank'>For Oil & Gas</a>
                                </li>
                                <li>
                                    <a href='https://www.skalillc.com/for-military/' target='_blank'>For Military</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href='https://www.skalillc.com/partners' target='__blank'>Partners</a>
                        </li>
                        <li>
                            <a href='https://www.skalillc.com/about-us' target='__blank'>About Us</a>
                        </li>
                        <li>
                            <a href='https://www.skalillc.com/faqs/' target='__blank'>FAQs</a>
                        </li>
                    </ul>
                    <div className='action-button'>

                         <button className='contact-btn' onClick={handleLoginClick} style={{backgroundColor:"white",color:'#357eff',padding:"7px 2rem", cursor:"pointer"}}>Log In</button>
                    </div>
                    <div className='action-button' style={{marginLeft:"12px"}}>

                        <a href='https://www.skalillc.com/lets-talk' target='__blank'> <button className='contact-btn' style={{padding:"7px 20px",marginLeft:'12px', cursor:"pointer"}}>Contact Us</button></a>
                    </div>
                </div>
        </header>
    );
}

export default Header;
